import { Buffer } from "buffer";
import instance from "components/common/HandleApiFailure";
import { store } from "redux/store";
import { serviceTypes } from "./Types";
import {
  API_URL,
  LIBRARY_SERVICE,
  NOTIFICATION_SERVICE,
  RECOMMENDATION_SERVICE,
  REDIRECT_URI,
  USERPLAN_SERVICE,
  USER_SERVICE
} from "./URLConstants";

export const getAPIHeaders = () => {
  const { isImpersonated, userDetails } = store.getState().app.impersonationDetails;
  let header = { Authorization: "Bearer " + localStorage.getItem("id_token"), impersonateTo: "" };
  if (isImpersonated) header = { ...header, impersonateTo: userDetails.hltId };
  return header;
};

export function getServiceType(service?: string) {
  switch (service) {
    case serviceTypes.recommendation:
      return RECOMMENDATION_SERVICE;

    case serviceTypes.userplan:
      return USERPLAN_SERVICE;

    case serviceTypes.user:
      return USER_SERVICE;

    case serviceTypes.notification:
      return NOTIFICATION_SERVICE;

    default:
      return LIBRARY_SERVICE;
  }
}

export const axiosGet = async (url: string, service?: string, params?: any) => {
  try {
    const response = await instance.get(`${getServiceType(service)}${url}`, {
      params,
      headers: getAPIHeaders()
    });
    return response;
  } catch (error: any) {
    return error;
  }
};

export const axiosPost = async (url: string, service?: string, params?: any) => {
  try {
    const response = await instance.post(`${getServiceType(service)}${url}`, params, {
      headers: getAPIHeaders()
    });
    return response;
  } catch (error: any) {
    return error;
  }
};

export const axiosPatch = async (url: string, service?: string, params?: any) => {
  try {
    const response = await instance.patch(`${getServiceType(service)}${url}`, params, {
      headers: getAPIHeaders()
    });
    return response;
  } catch (error: any) {
    return error;
  }
};

export const axiosDelete = async (url: string, service?: string, params?: any) => {
  try {
    const response = await instance.delete(`${getServiceType(service)}${url}`, {
      params,
      headers: getAPIHeaders()
    });
    return response;
  } catch (error: any) {
    return error;
  }
};

export const axiosPostToken = async (url: string | undefined, code?: string) => {
  const params = code
    ? {
        code,
        grant_type: process.env.REACT_APP_GRANT_TYPE,
        redirect_uri: REDIRECT_URI
      }
    : {
        grant_type: "refresh_token",
        refresh_token: localStorage.getItem("refresh_token"),
        redirect_uri: REDIRECT_URI
      };

  const headers = {
    "Content-Type": "application/x-www-form-urlencoded",
    Authorization:
      "Basic " +
      Buffer.from(process.env.REACT_APP_CLIENT_ID + ":" + process.env.REACT_APP_CLIENT_SECRET).toString("base64")
  };

  try {
    const response = await instance.post(`${url}`, params, { headers });
    return response;
  } catch (error) {
    return error;
  }
};

export const axiosRefreshToken = async () => {
  const params = {
    // grant_type: "refreshToken",
    refreshToken: localStorage.getItem("refresh_token")
    // redirect_uri: REDIRECT_URI
  };

  try {
    const response = await instance.post(`${API_URL}/refreshToken`, params);
    return response;
  } catch (error) {
    return error;
  }
};

export const axiosRevokePostToken = async (url: string | undefined) => {
  const data = {
    token: localStorage.getItem("id_token"),
    "X-XSRF-HEADER": "PingFederate",
    "Content-Type": "application/json"
  };
  const params = {
    id: localStorage.getItem("sessionId")
  };

  try {
    const response = await instance.post(`${url}`, params, { headers: data });

    return response;
  } catch (error) {
    return error;
  }
};

export const axiosPut = async (url: string, service?: string, params?: any) => {
  try {
    const response = await instance.put(`${getServiceType(service)}${url}`, params, {
      headers: getAPIHeaders()
    });
    return response;
  } catch (error: any) {
    return error;
  }
};

export const axiosFileUpload = async (url: string, service?: string, payload?: any) => {
  try {
    const response = await instance.post(`${getServiceType(service)}${url}`, payload, {
      headers: {
        ...getAPIHeaders(),
        accept: "application/json",
        "Content-Type": "multipart/form-data"
      }
    });
    return response;
  } catch (error: any) {
    return error;
  }
};

export const axiosFileDownload = async (url: string, service?: string) => {
  try {
    const response = await instance.get(`${getServiceType(service)}${url}`, {
      headers: {
        ...getAPIHeaders(),
        accessRole: "ADMIN",
        accept: "application/octet-stream"
      },
      responseType: "blob"
    });
    return response;
  } catch (error: any) {
    return error;
  }
};

export const axiosPostFileDownload = async (url: string, service?: string, params?: any) => {
  try {
    const response = await instance.post(`${getServiceType(service)}${url}`, params, {
      headers: getAPIHeaders(),
      responseType: "blob"
    });
    return response;
  } catch (error: any) {
    return error;
  }
};
